import { Portal, Select, createListCollection } from "@chakra-ui/react"
import { useState, useEffect } from "react"
import { ColorMode, useColorMode } from "./color-mode"
import { useAuth } from "./auth-context"
import { updateUserTheme } from "@/api"

interface ThemeSelectProps {
    fontFamily?: string,
}

export const ThemeSelect = (props : ThemeSelectProps) => {
    const {fontFamily} = props
    const { theme, setColorMode } = useColorMode()
    const { user, updateUser } = useAuth()
    const [value, setValue] = useState<string[]>([theme])

    // Update internal state when theme changes externally (e.g., from user data load)
    useEffect(() => {
        if (theme) {
            setValue([theme])
        }
    }, [theme])

    const handleValueChange = async (e: { value: string[] }) => {
        const newValue = e.value[0]
        if (!newValue) return

        setValue(e.value)
        setColorMode(newValue as ColorMode)

        if (user && user.nyssoguid) {
            try {
                await updateUserTheme(user.nyssoguid, newValue)
                if (updateUser) {
                    updateUser({ theme: newValue }) // Update local user state to prevent UserThemeSetter from fighting
                }
                console.log(`Theme updated in backend: ${newValue}`)
            } catch (error) {
                console.error("Failed to update theme in backend:", error)
            }
        }
    }

    return (
        <Select.Root size={'xs'}
            collection={frameworks}
            width="320px"
            value={value}
            onValueChange={handleValueChange}
            fontFamily={fontFamily}
        >
            <Select.HiddenSelect />
            <Select.Label></Select.Label>
            <Select.Control>
                <Select.Trigger>
                    <Select.ValueText placeholder="Select Theme" />
                </Select.Trigger>
                <Select.IndicatorGroup>
                    <Select.Indicator />
                </Select.IndicatorGroup>
            </Select.Control>
            <Portal>
                <Select.Positioner>
                    <Select.Content zIndex={1450}>
                        {frameworks.items.map((framework) => (
                            <Select.Item fontFamily={fontFamily} item={framework} key={framework.value}>
                                {framework.label}
                                <Select.ItemIndicator />
                            </Select.Item>
                        ))}
                    </Select.Content>
                </Select.Positioner>
            </Portal>
        </Select.Root>
    )
}

const frameworks = createListCollection({
    items: [
        { label: "Light", value: "light" },
        { label: "Dark", value: "dark" },
        { label: "System", value: "system" },
    ],
})